
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class WPLoader extends Vue {
  @Prop({ default: 34 })
  private readonly size?: string | number
}
